import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions } from "reducers/environment";

export const useUifVerify = () => {
    const dispatch = useDispatch();
    const [uifDetails, setUifDetails] = useState([]);
    const uifDetailsRequest = useSelector((state) => state.environment.uifDetailsRequest);
    const { status: uifDetailsStatus, value: uifDetailsValue, error: uifDetailsError } = uifDetailsRequest;

    const selectorsRequest = useSelector((state) => state.environment.generalDataSelectorsRequest);
    const { status: selectorsStatus, value: selectorsValue } = selectorsRequest;

    useEffect(() => {
        if (selectorsStatus === "SUCCESS") {
            dispatch(environmentActions.verifyUifDetails(selectorsValue?.documentNumber));
        }
    }, [selectorsStatus, selectorsValue]);

    useEffect(() => {
        // uifDetailsRequest
        if (uifDetailsStatus === "SUCCESS") {
            setUifDetails(uifDetailsValue);
        }
    }, [uifDetailsStatus, uifDetailsValue, uifDetailsError]);

    return { uifDetails, uifDetailsStatus };
};

export default useUifVerify;
